import { render } from "./QuestionsMultiChoiceMultiCol.vue?vue&type=template&id=e490f694"
import script from "./QuestionsMultiChoiceMultiCol.vue?vue&type=script&lang=js"
export * from "./QuestionsMultiChoiceMultiCol.vue?vue&type=script&lang=js"

import "./QuestionsMultiChoiceMultiCol.vue?vue&type=style&index=0&id=e490f694&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__